<template>
  <div
        class="modal trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >IMPORT HOLDINGS</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- Chart -->
              <div class="chart">
                <img src="@/assets/img/vector/upload-csv01.png" class="w-25 img-fluid" alt="Import" />
                <h4>
                  <i class="fas fa-info-circle"></i> INFORMATION
                </h4>
                <p class="modalp">Please select a CSV file for upload.</p>
                <p v-if="lastUploadedDate" style="color: #086f08;font-weight: 500;" class="modalp">Last Uploaded Date : {{moment(lastUploadedDate).format("MMMM DD YYYY, h:mm:ss a")}}</p>
                <progress v-if="uploadPercentage && !success" max="100" :value.prop="uploadPercentage"></progress><br>
                <label for="file-upload" class="custom-file-upload btn btn-primary my-2">
                  UPLOAD CSV
                  <i v-if="!loading" class="fas fa-cloud-upload-alt"></i>
                  <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </label>
                <input id="file-upload" type="file" accept=".csv"  @change="uploadToS3('input')" />
                <div v-if="error" class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  File upload failed. Please try again
                </div>
                <div  v-if="success" class="import-success">
                  <h4 class="text-success"><i class="fas fa-check"></i> IMPORT SUCCESS. FILE IS UNDER PROCESS </h4>
                  <div v-if="moduleName == 'IMS'" class="import-success">
                        <div class="summary-wrap">
                            <div class="opn-wrap">
                            <a href="#">
                                Holdings 
                                <router-link to="/ims/ims-inventory">                       
                                  <button @click="$emit('close')" type="submit" class="btn btn-primary my-2">GO <i aria-hidden="true" class="fa fa-arrow-circle-right"></i></button>
                                </router-link>
                            </a>
                            </div>
                        </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>
<script>
    import authService from "@/authService";
    // import config from "@/config";
    import config from "@/config";
    export default {
        name: 'inventoryImportmodal',
        components :{
            
        },
        props :["moduleName"],
        data() {
            return {
                loading : false,
                error : null,
                errors: [],
                success : false,
                uploadPercentage: 0,
                lastUploadedDate : null
                
            };
        },
        methods: {
          uploadToS3: function() {
            this.error = false;
            this.success = false;
            const configOption = {
                onUploadProgress: progressEvent => {
                  //console.log(progressEvent.loaded);
                  this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
                },
                // headers: { 'org-token' : authService.getOrgToken(),'Content-Type': 'multipart/form-data' }
            }
            var files = document.getElementById("file-upload").files;
            if (!files.length) {
              return alert("Please choose a file to upload first.");
            }
            let formData = new FormData();
            var fileToUpload = files[0];
            formData.append('file', fileToUpload);
            this.loading = true;
            this.$http
            .post(
              config.baseUrlBidSide +
                "/file/s3-upload?title=Testtitle&description=Testdescription&folder=inventory",
                formData,
                configOption
                
            )
            .then((result) => {
              this.inventoryFileUpload(result.data.key) 
            })
            .catch(e => {
                console.log("Error", e);
                this.loading = false;
                this.error = true;
                this.success = false;
              });

          },
          inventoryFileUpload(filePath){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            let data  =  {
                "key": filePath,
                "cognitoSub" : authService.getUser().cognitoSub
            }
            this.$http
            .post(
              config.baseUrlBidSide +
                "/fileupload/inventory",
               data,
               auth
            )
            .then(() => {
              this.loading = false;
              this.error = false;
              this.success = true;
              this.$root.$emit("holdingimported");   
              localStorage.setItem("INVUPLOADSTATUS", "INPROGRESS");              

            })
            .catch(e => {
                console.log("Error", e);
                this.loading = false;
                this.error = true;
                this.success = false;
              });
          },
          filelogs(){
            this.loading = true;
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlAutoBidder + "/logs/file-upload"+
                "?offset=0&limit=1&fetchLatestCreatedDates=true&fileType=HOLDING",
                auth
              )
              .then((result) => {
                console.log(result)
                this.lastUploadedDate = result.data.HOLDING;

                  // if(result.data.length > 0){
                  //   this.lastUploadedDate = result.data.HOLDING;
                  // }
                  this.loading = false;

              })
              .catch(e => {
                console.log(e);
                this.loading = false;
              });
          }
          
        },
        mounted() {
          this.filelogs()
        }
    };
    </script>